
/**
 *      Data-driven UI for horizontal filters of data types (groups)
 *
 *      @author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *     Created on 09/19/2017
 *     Modified on 01/22/2020
 */

/**
 * Display horizontal group filters menu
 */
function displayGroupView( successCallback, failureCallback ) {
    var layout = new SearchGroupLayoutView( { el: '#group-menu' } );
    layout.render();

    // select "All" grouping by default
    highlightCurrentGroup();

    // Display horizontal group menu
    getGroupMenu( successCallback, failureCallback );

}

/**
 * Layout view of the group menu
 */
var SearchGroupLayoutView = Backbone.Marionette.LayoutView.extend({
    template: '#group-template'
});

/**
 * Fetch group menu from DMR
 * @param successCallback {Function} - function to call on success
 * @param failureCallback {Function} - function to call on failure
 */
function getGroupMenu( successCallback, failureCallback ) {

    var alias,
        url;

    url = "/dmr/api/v1/group";

    // Get global search alias
    alias = App.globalState.alias;
    if ( alias ) {
        url += "/" + alias;
    }
    makeAjaxRequest( url, successCallback, failureCallback );
}

/**
 * Display DMR group filters
 * @returns {Function}
 */
function displayDMRGroup() {
    /**
     * Callback that is called when the call to get groups from Data Model Registry succeeds
     * @param data {object} - JSON data model for groups
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {

        var group;
        if ( data ) {
            // Save group model into the global state
            if ( ! App.globalState.TypeGroups ) {
                saveModelGroup( data );
            }
            group = convertGroupModel( data );
            displayGroup( group );

            if ( App.globalState.query ) {
                var start = App.globalState.currentPage > 1 ? (App.globalState.currentPage - 1) * App.globalState.pageSize : 0;
                doSearch( App.globalState.query, start, App.globalState.pageSize, successResponseCallback );
            }
        }

    };
}

/**
 * Display group filters
 * @param data {object} - JSON group model
 */
function displayGroup( data ) {

    var groupMenuId = '#group-menu',
        groupListId = '#group-list',
        layoutView,
        item,
        keys,
        key,
        i;

    if ( data ) {

        // Clear previously rendered group list
        if ( $( groupListId ) ) {
            $( 'ul' + groupListId ).empty();
        }

        layoutView = new SearchGroupLayoutView( { el: groupMenuId } );

        // Add the "All" group
        addGroupRegion( 'selectAll', layoutView, 'All' );

        for ( i = 0; i < data.length; i++ ) {

            item = data[ i ];
            keys = Object.keys( item );

            if ( keys && keys.length === 1 ) {
                key = keys[ 0 ];
                addGroupRegion( key, layoutView, item[ key ] );
            }
        }

        // Attach a listener to each group item in the menu
        $('.select-group').on('click', function(event) {
            clickOnGroup( event );
        });

        highlightCurrentGroup();

    }
}

/**
 * Create new region in the layout and the DOM
 * @param key {string} - unique name of the group
 * @param layoutView {object} - Backbone Layout View for search groups
 * @param textContent {string} - display name of the group
 */
function addGroupRegion( key, layoutView, textContent ) {

    var element,
        link;

    if ( layoutView && key ) {
        layoutView.addRegion( key, '#' + key );

        element = document.createElement( 'li' );
        element.id = key + '-item';

        link = document.createElement( 'a' );
        link.id = key;
        link.textContent = textContent;
        link.setAttribute( "class", "select-group" );

        element.appendChild( link );
        addDOMElement( element, 'group-list' );
        element.setAttribute( "class", "sub-menu-item pull-left" );
    }
}

/**
 * Click on one of the horizontal group filters
 * @param event {object} - click event
 */
function clickOnGroup( event ) {
    var currentTarget,
        id;

    if ( event ) {
        event.preventDefault();
        currentTarget = event.currentTarget;
        if ( currentTarget && currentTarget.id ) {
            id = currentTarget.id;
            if ( id ) {
                if ( id === 'selectAll' || id === '#selectAll' ) {
                    App.globalState.filterGroups = '';
                    initializeAllGroup();
                } else {
                    App.globalState.filterGroups = id;
                }
                selectGroupFilter( '#' + id );
            }
        }
    }
}

/**
 * Empty type, group and filters parameters from the URL once 'All' group is selected
 */
function initializeAllGroup() {

    var query,
        type,
        group,
        filters,
        URL,
        typeIndex,
        groupIndex,
        filtersIndex,
        indexArray,
        sortedIndexArray,
        dateValue,
        index,
        newUrl,
        oldUrl,
        i;

    query = getQueryFromURL( Backbone.history.getFragment() );
    type = getTypeStringFromURL( Backbone.history.getFragment() );
    filters = getFiltersStringFromURL( Backbone.history.getFragment() );
    group = getGroupNameFromURL();

    // Check the order of parameters in the URL
    URL = Backbone.history.getFragment();

    if ( URL ) {

        typeIndex = URL.indexOf( 'type=' );
        groupIndex = URL.indexOf( 'group=' );
        filtersIndex = URL.indexOf('filters=');
        indexArray = [ typeIndex, groupIndex, filtersIndex ];
        sortedIndexArray = indexArray.sort();

        // Construct the URL to update from (oldUrl) and the URL to update to (newUrl)
        newUrl = '?q=' + query;
        oldUrl = '?q=' + query;

        // Order the URL's by the indexes of the parameters in the URL

        for ( i = 0; i < sortedIndexArray.length; i++ ) {
            index = sortedIndexArray[i];
            if ( index !== -1 ) {
                if ( index === typeIndex ) {
                    oldUrl += '&type=' + type;
                }
                else if ( index === filtersIndex ) {
                    oldUrl += '&filters=' + filters + ";";
                }
                else if ( index === groupIndex ) {
                    oldUrl += '&group=' + group;
                }
            }

        }

        // Check if date filter is set in the global store
        if ( App.globalState.dateFilter !== "all" ) {
            // Add date filter to the URL
            dateValue = getDateValue( App.globalState.dateFilter );
            newUrl += "&filters=indexed|gt|" + dateValue + ";";
        }

        updateEndURL( newUrl, oldUrl, true );
    }

}

/**
 * Convert DMR group model properties array into an object of key-value pairs
 * @param data {object} - JSON group model
 * @returns {Array}
 */
function convertGroupModel( data ) {

    var groupArray = [],
        properties,
        model,
        propertiesArray,
        item,
        group,
        i;

    if ( data ) {
        properties = data.properties;
        if ( properties && properties.length === 1 ) {
            model = properties[ 0 ];
            if ( model ) {
                propertiesArray = model.properties;
                if ( propertiesArray ) {
                    for ( i = 0; i < propertiesArray.length; i++ ) {
                        item = propertiesArray[ i ];
                        group = {};
                        if ( item && item.name && item.label ) {
                            group[ item.name ] = item.label;
                            groupArray.push( group );
                        }
                    }
                }
            }
        }
    }

    return groupArray;
}

/**
 * Select one of the horizontal group filters
 * @param id {string} - group filter DOM id
 */
function selectGroupFilter( id ) {

    highlightGroupMenu( id );

    // Remove all global filters
    App.globalState.currentFilters.reset( null );

    // Check if indexed field is selected
    if ( App.globalState.dateFilter !== "all" ) {
        addDateFilter( App.globalState.dateFilter );
    }
    // Update URL based on global filters and redirect
    updateURLFromFilters( true );
}

/**
 * Highlight group filter
 * @param id {string} - group filter DOM id
 */
function highlightGroupMenu( id ) {
    var subMenu = $( '#sub-menu' ),
        oldId;

    subMenu.find( 'li' ).removeClass( 'active' );
    oldId = id;
    if ( id && id.substr(0,1) !== '#' ) {
        id = '#' + id ;
    }
    if ( id ) {
        subMenu.find( id ).addClass( 'active' );
        subMenu.find( id ).parent().addClass( 'active' );

        checkURLWithGroup( oldId );
    }
}

/**
 * Check if current group has only one data type. Update URL if it does.
 * @param id {string} - group filter DOM id
 */
function checkURLWithGroup( id ) {

    var typeStrings,
        types,
        type,
        urlType,
        query,
        oldUrl,
        newUrl;

    if ( App && App.globalState && App.globalState.TypeGroups && App.globalState.TypeGroups[ id ] ) {
        typeStrings = App.globalState.TypeGroups[ id ];

        if ( typeStrings ) {
            types = typeStrings.split(',');
            if ( types && types.length === 1 ) {
                type = types[ 0 ];

                // Check current URL

                urlType = getTypeStringFromURL( Backbone.history.getFragment() );

                if ( type && ! urlType ) {
                    // Update the URL and reload the results
                    query = getQueryFromURL( Backbone.history.getFragment() );
                    oldUrl = '?q=' + query;
                    newUrl = '?q=' + query + '&type=' + type;

                    updateEndURL( newUrl, oldUrl, true );
                }
            }
        }
    }
}

/**
 * Save a group model to a local store
 * @param model {object} - data JSON model
 */
function saveModelGroup( model ) {

    var properties,
        data,
        groups,
        name,
        types,
        group,
        typesString,
        i,
        j;

    if ( ! App.globalState.TypeGroups ) {
        App.globalState.TypeGroups = {};
    }

    if ( model ) {
        properties = model.properties;
        if ( properties && properties.length === 1 ) {
            data = properties[ 0 ];
            if ( data ) {

                groups = data.properties;
                if ( groups ) {

                    for ( i = 0; i < groups.length; i++ ) {

                        group = groups[ i ];
                        if ( group ) {
                            name = group.name;
                            types = group.fields;

                            // Save group types into a global variable
                            if ( name && types ) {

                                typesString = '';
                                // Convert types array into a concatenated string
                                for ( j = 0; j < types.length; j++ ) {
                                    typesString += types[ j ];
                                    if ( j < types.length - 1 ) {
                                        typesString += ",";
                                    }
                                }
                                App.globalState.TypeGroups[ name ] = typesString;
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Get the group  name from the current URL
 * @returns {*}
 */
function getGroupNameFromURL() {
    var result,
        current,
        queryFilters,
        urlArray;

    current = Backbone.history.getFragment();
    if ( current ) {
        queryFilters = current.split('?');
        if ( queryFilters && queryFilters.length > 1 ) {
            urlArray =  queryFilters[ 1 ].split( '&group=' ) ? queryFilters[ 1 ].split('&group=') : [];
            if ( urlArray && urlArray.length > 1 ) {
                result = urlArray[ 1 ];
            }
        }
    }
    return result;
}

/**
 * Get group name from the current Search URL ?q=[query]&type=[type]&group=[group]
 * @returns {*}
 */
function getGroupStringFromURL() {
    var result,
        current,
        urlArray,
        paramString,
        params;

    current = Backbone.history.getFragment();

    if ( current ) {
        urlArray = current.split( '&group=' );
        if ( urlArray && urlArray.length === 2 ) {
            // group found in the URL
            paramString = urlArray[ 1 ];
            if ( paramString ) {
                params = paramString.split('&');
                if ( params && params.length > 0 ) {
                    result = params[ 0 ];
                }
            }
        }
    }
    return result;
}

/**
 * Highlight current group filter
 */
function highlightCurrentGroup() {
    var group = getGroupNameFromURL();
    if ( group ) {
        highlightGroupMenu( group );
    } else {
        highlightGroupMenu( 'selectAll' );
    }
}